import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import produce from 'immer';
import set from 'lodash/set';
import { getEscrowEncryptApplication, postEscrowPaymentsIntegration } from 'app/api';

const CHANGE = 'escrow.cashpay/CHANGE';
export const change = createAction(CHANGE);

const GET_ESCROW_APPLICATION = 'escrow.cashpay/GET_ESCROW_APPLICATION';
export const getEscrowApplicationAction = createAction(GET_ESCROW_APPLICATION, getEscrowEncryptApplication);

const POST_ESCROW_PAYMENTS_INTEGRATION = 'escrow.cashpay/POST_ESCROW_PAYMENTS_INTEGRATION';
export const postEscrowPaymentsIntegrationAction = createAction(POST_ESCROW_PAYMENTS_INTEGRATION, postEscrowPaymentsIntegration, ({ data }) => data);

const initialState = {
	encryptApplicationId: '',
	applicationInfo: null,
};

export default handleActions(
	{
		[CHANGE]: (state, action) =>
			produce(state, (draft) => {
				const { schema, name, value } = action.payload;
				set(draft, [...schema, name], value);
			}),
		...pender({
			type: GET_ESCROW_APPLICATION,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					draft.applicationInfo = action.payload.data;
				}),
		}),
		...pender({
			type: POST_ESCROW_PAYMENTS_INTEGRATION,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { orderId, transactionId } = action.meta;
					draft.applicationInfo.payment.paymentV2 = { orderId, transactionId };
				}),
		}),
	},
	initialState,
);
